import { getAppStore } from '@/store';
import { ScreenType } from '@/types/analytics';

/**
 * Determines the current screen type for analytics based on app state.
 *
 * Screen type mapping:
 * - library → chooser_screen
 * - create (no result) → generator_screen
 * - create (with result) → preview_screen
 * - result → preview_screen
 * - files → history
 */
export function getScreenType(): ScreenType {
  const { screen, resultFile } = getAppStore();

  switch (screen) {
    case 'library':
      return ScreenType.CHOOSER;
    case 'create':
      // If there's a result file, we're in preview mode
      if (resultFile) {
        return ScreenType.PREVIEW;
      }
      return ScreenType.GENERATOR;
    case 'result':
      return ScreenType.PREVIEW;
    case 'files':
      return ScreenType.HISTORY;
    case 'loading':
      return ScreenType.GENERATOR;
    default:
      return ScreenType.GENERATOR;
  }
}
